import { Navigate } from 'react-router-dom'
import { ReactNode } from 'react'

type UserRole = 'demo' | 'company_user' | 'company_admin' | 'super_admin'

interface ProtectedRouteProps {
  children: ReactNode
  requiredRole?: UserRole
}

const roleHierarchy: Record<UserRole, number> = {
  demo: 0,
  company_user: 1,
  company_admin: 2,
  super_admin: 3
}

export function ProtectedRoute({ children, requiredRole }: ProtectedRouteProps) {
  // Check if user is logged in
  const userStr = localStorage.getItem('user')

  if (!userStr) {
    return <Navigate to="/login" replace />
  }

  try {
    const user = JSON.parse(userStr)

    // Validate JSON format and check if role exists
    if (!user || !user.role) {
      return <Navigate to="/login" replace />
    }

    // Check role-based access if requiredRole is specified
    if (requiredRole) {
      const userRoleLevel = roleHierarchy[user.role as UserRole] ?? -1
      const requiredRoleLevel = roleHierarchy[requiredRole]

      if (userRoleLevel < requiredRoleLevel) {
        // User doesn't have sufficient permissions
        return <Navigate to="/access-denied" replace />
      }
    }

    // User is authenticated, render children
    return <>{children}</>
  } catch (error) {
    console.error('Failed to parse user data:', error)
    return <Navigate to="/login" replace />
  }
}
